module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-desktop-es.3016feed.png";